import * as z from "zod";
import { zodSortField } from "../utils";

const alphaFixed = (len: number, label: string) =>
  z
    .string()
    .regex(
      new RegExp(`^[A-Za-z0-9]{${len}}$`),
      `${label} doit contenir exactement ${len} caractères alphanumériques`,
    );

export const addRacArisRuleSchema = z.object({
  kvps: z.string().regex(/^[A-Z]{3}[ACNSV]\d{5}$/, "Le kvps est incohérent"),

  renterIdentifier: alphaFixed(4, "L’identifiant loueur"),

  financialOrganizationIdentifier: alphaFixed(
    6,
    "L’identification organisme financier",
  ),

  renterOperatorIdentifier: alphaFixed(
    6,
    "L’identification loueur titulaire/exploitant",
  ),

  isActive: z.boolean(),
});

export const editRacArisRuleSchema = addRacArisRuleSchema.extend({
  id: z.number(),
});

export const deleteRacArisRuleSchema = z.object({
  id: z.number(),
});

export const getRacArisRulesRequestSchema = z.object({
  sort: zodSortField([
    "kvps",
    "renterIdentifier",
    "financialOrganizationIdentifier",
    "renterOperatorIdentifier",
  ]),
});
